import LeIconSelect from './src';

// 为组件提供 install 安装方法，供按需引入
LeIconSelect.install = function(Vue) {
  Vue.component(LeIconSelect.name, LeIconSelect);
};

// 导出组件
export default LeIconSelect;
